/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 202309d9 (Tue Mar 17 17:42:15 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { ContentAsset, ContentAssetFromJSON, ContentAssetToJSON } from './'

/**
 *
 * @export
 * @interface PlaylistItem
 */
export interface PlaylistItem {
  /**
   * The unique identifier for the playlist item.
   * @type number
   * @memberof PlaylistItem
   */
  playlistItemKey: number
  /**
   * The key of the Widen asset associated with this playlist item.
   * @type number
   * @memberof PlaylistItem
   */
  widenAssetKey: number
  /**
   * The position of this item in the playlist.
   * @type number
   * @memberof PlaylistItem
   */
  position: number
  /**
   *
   * @type ContentAsset
   * @memberof PlaylistItem
   */
  asset?: ContentAsset
}

export function PlaylistItemFromJSON(json: any): PlaylistItem {
  return PlaylistItemFromJSONTyped(json, false)
}

export function PlaylistItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PlaylistItem {
  if (json === undefined || json === null) {
    return json
  }
  return {
    playlistItemKey: json['playlistItemKey'],
    widenAssetKey: json['widenAssetKey'],
    position: json['position'],
    asset: !exists(json, 'asset')
      ? undefined
      : ContentAssetFromJSON(json['asset']),
  }
}

export function PlaylistItemToJSON(value?: PlaylistItem | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    playlistItemKey: value.playlistItemKey,
    widenAssetKey: value.widenAssetKey,
    position: value.position,
    asset: ContentAssetToJSON(value.asset),
  }
}
